/**
 * How a student entered the scholarship for an award year.
 * String values match the API C# enum member names, since the API serializes enums as
 * strings (JsonStringEnumConverter) — keeping the dropdown value in sync with the wire format.
 */
export enum StudentType {
  New = 'New',
  Renewal = 'Renewal',
  PendingRenewal = 'PendingRenewal',
  RejectedRenewal = 'RejectedRenewal'
}
